import { ExportButton, PrintButton } from "Components/atoms/buttons/report-buttons"
import { openReportView, ReportViewKind } from "utils/report-snapshot"

interface ReportButtonsProps {
    title: string
    module: string
    // The page's own full CSV export, offered on the export page next to the table CSV
    fullExport?: () => void | Promise<void>
}

// Export + Print for report pages that don't use DataTableTemplate. Takes a snapshot of the
// page content (without the header and filter bar) and opens <page>/export or <page>/print.
const ReportButtons = ({ title, module, fullExport }: ReportButtonsProps) => {
    const open = (kind: ReportViewKind) => openReportView(kind, {
        title,
        module,
        content: document.querySelector<HTMLElement>(".page-content"),
        filters: document.querySelector<HTMLElement>(".search-form-container"),
        fullExport: kind === "export" ? fullExport : undefined,
    })

    return <>
        <ExportButton onClick={() => open("export")} />
        <PrintButton onClick={() => open("print")} />
    </>
}

export default ReportButtons
